import React, { useEffect, useReducer } from "react";
import QRious from "qrious";
import { useLocation } from 'react-router-dom';
import { hashCodeFromSeat } from "./helpers";
import { initialState, reducer } from "./state";
import { supabase } from "./App";


const numberToUrl = (play,seatKey) => `https://andmeteater.ee/vasta?seat=${hashCodeFromSeat(seatKey)}`;

const QRCodeBlock = ({ play,seatKey }) => {
    const canvasRef = React.useRef();

    const seat = seatKey.split("-").map((x,n) => n === 0 ? [,"parter","rõdu"][x] : x).join("-")

    React.useEffect(() => {
        new QRious({
            element: canvasRef.current,
            value: numberToUrl(play,seatKey),
            size: 160,
        });
    }, [seatKey]);

    return (
        <div style={{width: 160, margin: "20px", textAlign: "center"}}>
            <canvas ref={canvasRef} />
            <div style={{ fontSize: 16, marginTop: 2,fontWeight:"bold" }}>{seat}</div>
        </div>
    );
};

const QRCodeGrid = ({ perPage = 15 }) => {
    const location = useLocation();
    const play = location.pathname.split("/")[2];
    const [{seat_keys},dispatch] = useReducer(reducer, initialState);
    const pages = [];
    const sorted = seat_keys.sort((a, b) => {
        const [a1, a2, a3] = a.split('-').map(Number);
        const [b1, b2, b3] = b.split('-').map(Number);
        return a1 - b1 || a2 - b2 || a3 - b3;
    })
    for (let i = 0; i < seat_keys.length; i += perPage) {
        const pageNumbers = seat_keys.slice(i, i + perPage);
        pages.push(pageNumbers);
    }

      const getInitialData = async (dispatch) => {
        const query = (table,select) => supabase.from(table).select(select);
    
        const {data:seats} = await query("seats","left, top, n, vertical, area,row,start");
        dispatch({ type: "LOAD_SEATS", payload: seats });
      };
    
    useEffect(() => {
        getInitialData(dispatch);

    },[])

    return (
        <div>
            {pages.map((pageNumbers, pageIndex) => (
                <div
                    key={pageIndex}
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                    }}
                >
                    {pageNumbers.map((x) => (
                        <QRCodeBlock key={x} seatKey={x} play={play} />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default QRCodeGrid;